import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.4295 2.73138C9.78283 2.52959 10.2168 2.5297 10.5701 2.73138L16.0701 5.87494C16.4284 6.07966 16.6501 6.46037 16.6502 6.87299V13.1269C16.6502 13.5396 16.4284 13.9202 16.0701 14.1249L10.5701 17.2685C10.2167 17.4702 9.78287 17.4703 9.4295 17.2685L3.9295 14.1249C3.57128 13.9202 3.35041 13.5395 3.3504 13.1269V6.87299C3.35047 6.4604 3.57129 6.07967 3.9295 5.87494L9.4295 2.73138Z",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "10",
  cy: "10",
  r: "2.35",
  stroke: "currentColor",
  "stroke-width": "1.3"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }